/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Payment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import Tooltip from 'DesignSystem/Tooltip/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconExternalLink from 'DesignSystem/Svgs/TysiaIconExternalLink/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagIcon from 'DesignSystem/TysiaTag/TysiaTagIcon/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2InfoFilled from 'DesignSystem/Svgs/Tysiav2InfoFilled/index'
import Tysiav2MinusIcon from 'DesignSystem/Svgs/Tysiav2MinusIcon/index'
import Tysiav2PostPayment from 'DesignSystem/Svgs/Tysiav2PostPayment/index'
import Tysiav2ReturnIcon from 'DesignSystem/Svgs/Tysiav2ReturnIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Payment({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/Transactions/Transaction/EntityType/Payment"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsRed200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.200'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsRed900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.900'
        })
let entryAmountValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'amount',
format: fromFormat.numberMoney,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsGreen800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.800'
        })
let dtColorsGreen200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.200'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="Payment.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Payment.Vertical"
  data-view-path={viewPath}
 style={{'--btlr-1-12p2wE': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-2-12p2wE': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-3-12p2wE': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-4-12p2wE': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-12p2wE': dtColorsRed200,'--mt-6-12p2wE': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2MinusIcon
  viewPath={`${viewPath}/Tysiav2MinusIcon`}
 fill2={dtColorsRed900}
 width={6}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 weight="medium"
 data="entry.amount"
 format="/Data/format.js numberMoney"
 text={entryAmountValueData}
/>
<div
  data-testid="Payment.Vertical:1"
  data-view-path={viewPath}
 style={{'--ml-7-12p2wE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-8-12p2wE': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Payment.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="green"
 style="filled"
 marginTop={dtSpaceXxxs}
>
{childProps => (
<React.Fragment>
<TysiaTagIcon
{...childProps}
  viewPath={`${viewPath}/TysiaTagIcon`}
>
{childProps => (
<Tysiav2PostPayment
{...childProps}
  viewPath={`${viewPath}/Tysiav2PostPayment`}
 fill2={dtColorsGreen800}
 stroke={dtColorsGreen200}
 width={12}
 height={12}
/>
)}
</TysiaTagIcon>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Payment"
/>
</React.Fragment>
)}
</TysiaTag>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="ghost"
 marginLeft={dtSpaceXxxs}
 marginTop={3}
 height="auto"
 paddingLeft={0}
 paddingRight={0}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconExternalLink
{...childProps}
  viewPath={`${viewPath}/TysiaIconExternalLink`}
 fill={dtColorsWhite}
 width={13}
 height={13}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 text="applied on Sep 20, 2025, 9:00PM"
/>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 placement="bottom"
 offsetMainAxis={dtSpaceXs}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="ghost"
 marginLeft={dtSpaceXxxs}
 marginTop={3}
 height="auto"
 paddingLeft={0}
 paddingRight={0}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2InfoFilled
{...childProps}
  viewPath={`${viewPath}/Tysiav2InfoFilled`}
 width={13}
 height={13}
 fill2={dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<Tooltip
{...childProps}
  viewPath={`${viewPath}/Tooltip`}
 backgroundColor={dtColorsWhite}
 color={dtColorsNeutral900}
 height="auto"
 maxWidth={240}
 top={-12}
 left={0}
 className="new-shadow"
 whiteSpace="normal"
 text="TODO: Show additional metadata (created by, created at)"
 className="new-shadow"
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
</div>
<div
  data-testid="Payment.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-8-12p2wE': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal2}`}
>
<Tysiav2ReturnIcon
  viewPath={`${viewPath}/Tysiav2ReturnIcon`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Autopaid by Ollie Gallagher with credit card XXXX 0934 0530 (Terri Gallagher)"
 color={dtColorsNeutral600}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}